import { Input } from "@chakra-ui/react";
import {
  Control,
  Controller,
  FieldValues,
  RegisterOptions,
} from "react-hook-form";
import { NumericFormat } from "react-number-format";

interface Props {
  control: Control<FieldValues>;
  name: string;
  defaultValue?: string;
  height?: string;
  disabled?: boolean;
  placeholder?: string;
  maxLength?: number;
  hasError?: boolean;
  maxW?: string;
  rules?: RegisterOptions<FieldValues, string>;
  prefix?: string
}

export const InputCurrency = ({
  control,
  name,
  height,
  placeholder,
  defaultValue,
  disabled,
  maxLength,
  hasError,
  maxW,
  rules,
  prefix = "$ "
}: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field }) => (
        <NumericFormat
          {...field}
          data-testid="input-currency"
          thousandSeparator="."
          decimalSeparator=","
          prefix={prefix}
          paddingLeft="8px"
          disabled={disabled}
          decimalScale={2}
          fixedDecimalScale
          allowNegative={false}
          customInput={Input}
          placeholder={placeholder ?? "Ingresar monto"}
          height={height}
          maxLength={maxLength}
          border={hasError ? "1px solid red" : "1px solid gray"}
          _hover={{ borderColor: hasError ? "red.500" : "" }}
          _focus={{
            borderColor: hasError ? "red.600" : "",
            boxShadow: hasError ? "0 0 0 1px red" : "",
          }}
          maxW={maxW}
        />
      )}
    />
  );
};
